export const getLocationOrigin = (): string => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  switch (process.env.NODE_ENV_SSR) {
    case "staging":
      return "https://staging.smmplanner.com";
    case "staging-io":
      return "https://staging.smmplanner.bind.pw";
    case "production-io":
      return "https://smmplanner.io";
    case "production":
      return "https://smmplanner.com";
    default:
      return "http://localhost";
  }
};
